module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addFile",
    attrs: {
      "updateFileList": _vm.updateFileList,
      "updatePicList": _vm.updatePicList
    }
  }, [_c('div', {
    staticClass: "addCourseware"
  }, [_c('div', {
    staticClass: "addCourseBtn"
  }, [_c('p', [_vm._v("课件类型：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n        从我的电脑选择\n        "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "ppt/*,pptx/*,pdf/*,doc/*,docx/*,rtf/*,xls/*"
    },
    on: {
      "change": function($event) {
        return _vm.changeFn($event, 1)
      }
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "filelist"
  }, _vm._l((_vm.FileList), function(file, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.removeFile(index, 1)
        }
      }
    }), _vm._v(" "), _c('a', [_c('img', {
      attrs: {
        "src": file.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(file.attach_name))])]), _vm._v(" "), _c('ProgressBar', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!file.creator),
        expression: "!file.creator"
      }],
      attrs: {
        "step": _vm.steps,
        "initVal": _vm.initVal,
        "stopVal": _vm.stopVal,
        "isOk": _vm.isOk
      },
      on: {
        "callback": _vm.show
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "addOther"
  }, [_c('div', {
    staticClass: "addCourseBtn"
  }, [_c('p', [_vm._v("其他图片：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n        从我的电脑选择 "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.changeFn($event, 2)
      }
    }
  })])]), _vm._v(" "), _c('ul', _vm._l((_vm.PicList), function(file, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.removeFile(index, 2)
        }
      }
    }), _vm._v(" "), _c('a', [_c('img', {
      attrs: {
        "src": file.fileurl || file.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(file.attach_name))])]), _vm._v(" "), _c('ProgressBar', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!file.creator),
        expression: "!file.creator"
      }],
      attrs: {
        "step": _vm.steps,
        "initVal": _vm.initVal,
        "stopVal": _vm.stopVal,
        "isOk": _vm.isOk
      },
      on: {
        "callback": _vm.show
      }
    })], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b852794a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upload/uploadFile1.vue
// module id = 600
// module chunks = 1 2 3 4 5 6 7 8